import { lazy } from "react";

// TEXT

// STYLES

// DATA

// TYPES

// CONSTANTS
/** legal-frontend is lazy-loaded, so only demo org users fetch it; the gate's modal is a further async chunk */
export const DemoTermsGate = lazy(() =>
  import("@songtradr-one/legal-frontend/context").then((module) => ({
    default: module.DemoTermsGate,
  })),
);

// FUNCTIONS

// ASSETS
